import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GaTrackingEventCategory, GaTrackingEventName, GATrackingEventType } from '../../constants';

export class GaTrackingInstallationServicesDetailsEvent implements GATrackingEvent {
  getEventType(): GATrackingEventType {
    return GATrackingEventType.InstallationServicesDetails;
  }

  getPayload(): GATrackingEventPayload {
    const productPromoViewTracking = {
      category: GaTrackingEventCategory.Navigation,
    };

    return {
      event: GaTrackingEventName.InstallationServicesDetails,
      gtmCustom: productPromoViewTracking,
    };
  }
}
